import { z } from "zod";

export interface BackupCheckEntity {
  id: number;
  fechaCreacion: string;
  titular: string;
  nroCuenta: string;
  monto: number;
  solicitante: string;
  estadoDescripcion: string;
}

export interface BackupCheckAccountInfo {
  titular: string;
  nroCuenta: string;
  banco?: string;
}

export interface BackupCheckDetail {
  id: number;
  montoTransferido: number;
  fechaTransferencia: string;
  sucursal: string;
  solicitante: string;
  estado: string;
  mensajes: {
    texto: string;
    fechaHora: string;
    usuario: string;
    esUsted: boolean;
  }[];
  origen: BackupCheckAccountInfo;
  destino: BackupCheckAccountInfo;
  nroCheque: string;
}

export const backupChecksFilterSchema = z.object({
  backup_date: z.any().optional(),
  account_number: z.any().optional(),
  backup_amount: z.any().optional(),
  backup_requester: z.any().optional(),
  estados: z.any().optional(),
});

export interface PrintCheckRequest {
  date: string;
  datePayment: string;
  payeeName: string;
  amount: number;
}
